module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-sidebar-menu",
    class: [!_vm.isCollapsed ? 'vsm-default' : 'vsm-collapsed'],
    style: ({
      'width': _vm.sidebarWidth
    }),
    on: {
      "mouseleave": _vm.mouseLeave
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCollapsed),
      expression: "!isCollapsed"
    }],
    staticClass: "m-2"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo-transparent.png",
      "alt": "Royal Pag",
      "width": "132px"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCollapsed),
      expression: "isCollapsed"
    }],
    staticClass: "m-2"
  }, [_c('img', {
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": "/static/img/icon-crown.png"
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "vsm-list fa-2x",
    staticStyle: {
      "padding-left": "10px"
    },
    style: ([{
      'height': '-webkit-fill-available',
      'margin-bottom': '120px'
    }, {
      'overflow': 'hidden auto'
    }])
  }, [_vm._l((_vm.menu), function(item, index) {
    return [(item.header) ? [(!_vm.isCollapsed) ? _c('div', {
      key: index,
      staticClass: "vsm-header"
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()] : _c('item', {
      key: index,
      attrs: {
        "item": item,
        "firstItem": true,
        "isCollapsed": _vm.isCollapsed
      }
    })]
  })], 2), _vm._v(" "), (_vm.isCollapsed) ? _c('div', {
    style: ([{
      'position': 'absolute'
    }, {
      'top': (_vm.mobileItemPos + "px")
    }, {
      'left': '0px'
    }, {
      'z-index': 30
    }, {
      'width': _vm.width
    }])
  }, [_c('mobile-item', {
    attrs: {
      "item": _vm.mobileItem
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-animation"
    }
  }, [(_vm.mobileItem) ? _c('div', {
    staticClass: "vsm-mobile-bg",
    style: ([{
      'position': 'absolute'
    }, {
      'left': '0px'
    }, {
      'right': '0px'
    }, {
      'top': '0px'
    }, {
      'height': (_vm.mobileItemHeight + "px")
    }])
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "vsm-dropdown",
    style: ([{
      'position': 'absolute'
    }, {
      'top': (_vm.mobileItemHeight + "px")
    }, {
      'left': _vm.sidebarWidth
    }, {
      'right': '0px'
    }, {
      'max-height': ("calc(100vh - " + (_vm.mobileItemPos + _vm.mobileItemHeight) + "px)")
    }, {
      'overflow-y': 'auto'
    }])
  }, [_c('transition', {
    attrs: {
      "name": "show-animation"
    }
  }, [(_vm.mobileItem && _vm.mobileItem.child) ? _c('div', {
    staticClass: "vsm-list"
  }, _vm._l((_vm.mobileItem.child), function(subItem, index) {
    return _c('sub-item', {
      key: index,
      attrs: {
        "item": subItem
      }
    })
  }), 1) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCollapsed),
      expression: "isCollapsed"
    }]
  }, [_c('button', {
    staticClass: "logout-btn fas fas fa-door-closed",
    on: {
      "click": _vm.logout
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCollapsed),
      expression: "!isCollapsed"
    }],
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('button', {
    staticClass: "collapse-btn fas fa-arrows-alt-h",
    on: {
      "click": _vm.toggleCollapse
    }
  }), _vm._v(" "), [_c('the-menu')]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-btn-logout-open"
  }, [_c('button', {
    staticClass: "vsm-icon fas fa-door-closed",
    staticStyle: {
      "float": "left",
      "height": "30px",
      "line-height": "0px",
      "width": "30px",
      "margin-left": "20px",
      "margin-top": "5px",
      "cursor": "pointer",
      "text-align": "center",
      "background": "#1e1e21",
      "border-radius": "3px",
      "border": "none",
      "color": "#fff"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "vsm-title",
    staticStyle: {
      "font-size": "16px",
      "padding-top": "4px",
      "cursor": "pointer",
      "width": "100%"
    }
  }, [_vm._v("Sair")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e14d9340","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/SidebarMenu.vue
// module id = Zwna
// module chunks = 36